function startOfDay(value) {
  const date = new Date(value);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * Mockup-aligned ampel status for milestone timeline (Meilensteine.jsx / milestoneUtils.js).
 * @returns {{ ampel: 'green'|'yellow'|'red', deviation: { type: 'green'|'red'|'neutral', key: string, count?: number } }}
 */
export function calculateMilestoneDisplayStatus(targetDate, actualDate, today = new Date()) {
  if (!targetDate) {
    return {
      ampel: 'green',
      deviation: { type: 'neutral', key: 'dash' },
    };
  }

  const todayMidnight = startOfDay(today);
  const targetMidnight = startOfDay(targetDate);
  const diffDays = Math.round(
    (targetMidnight.getTime() - todayMidnight.getTime()) / (1000 * 60 * 60 * 24),
  );

  if (actualDate) {
    const actualMidnight = startOfDay(actualDate);
    const deviationDays = Math.round(
      (actualMidnight.getTime() - targetMidnight.getTime()) / (1000 * 60 * 60 * 24),
    );

    if (deviationDays === 0) {
      return {
        ampel: 'green',
        deviation: { type: 'green', key: 'onTime' },
      };
    }
    if (deviationDays > 0) {
      return {
        ampel: 'green',
        deviation: { type: 'red', key: 'daysLate', count: deviationDays },
      };
    }
    const absDays = Math.abs(deviationDays);
    return {
      ampel: 'green',
      deviation: { type: 'green', key: 'daysEarly', count: absDays },
    };
  }

  if (diffDays < 0) {
    return {
      ampel: 'red',
      deviation: { type: 'red', key: 'daysOverdue', count: Math.abs(diffDays) },
    };
  }

  if (diffDays <= 7) {
    return {
      ampel: 'yellow',
      deviation: { type: 'neutral', key: 'dash' },
    };
  }

  return {
    ampel: 'green',
    deviation: { type: 'neutral', key: 'dash' },
  };
}

export function formatMilestoneDate(value) {
  if (!value) return '–';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '–';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
}

export function filterMilestonesByAmpel(milestones, filter) {
  if (!filter || filter === 'all') {
    return milestones;
  }
  return milestones.filter((milestone) => {
    const { ampel } = calculateMilestoneDisplayStatus(
      milestone.dueDate,
      milestone.actualDate,
    );
    return ampel === filter;
  });
}

export function sortMilestonesForTimeline(milestones) {
  return [...milestones].sort((a, b) => {
    const aTime = a.dueDate ? new Date(a.dueDate).getTime() : 0;
    const bTime = b.dueDate ? new Date(b.dueDate).getTime() : 0;
    return aTime - bTime;
  });
}
